import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { plugins } from 'chart.js';
import { latLng, LatLng, tileLayer, LayerGroup } from 'leaflet';
import { interval, max, pipe, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { TramDoGiaTriDoService } from 'src/app/thmp-monitoring/services/tram-do-gia-tri-do.service';
import { TramDoService } from 'src/app/thmp-monitoring/services/tram-do.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import * as Highcharts from 'highcharts';
import { AuthenticationService, BasicUserInfo } from 'sv-shared';
import { Router } from '@angular/router';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  dataSource: any[] = [];
  listTramDo: any[] = [];
  itemTramDo = { id: 0, title: '', address: '', gpsLat: '', gpsLong: '', trangThaiHoatDong: 0, trangThaiHoatDongData: 0 };
  idTramDo: 0;
  chartDatas: any[] = [];

  chartDatas1: any[] = [];
  dataSource1: any[] = [];

  plugin = [ChartDataLabels];
  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        color: '#fff',
        padding: 0,
        zIndex: 99999,
        font: {
          weight: 'lighter'
        }
      },
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      customCanvasBackgroundColor: {
        color: 'lightGreen',
      }
    },
    scales: {
      x: {
        ticks: {
          color: 'rgb(204, 204, 220)',
          font: {
            weight: 'lighter'
          }
        },
      },
      y: {
        ticks: {
          color: 'rgb(204, 204, 220)',
          font: {
            weight: 'lighter'
          }
        },
        grid: {
          display: true,
          color: 'rgba(204, 204, 220, 0.12)'
        },
        max: (scale) => (
          scale.chart.data.datasets.reduce((acc, curr) => {
            const max = Math.max(...curr.data);
            acc = max > acc ? max : acc;
            acc = acc + acc * 20 / 100;
            acc = acc <= 360 ? acc : 360;
            return acc;
          }, Number.MIN_SAFE_INTEGER))
      },
    },
  };

  @ViewChild('mapRef', { static: true }) mapElement: ElementRef;
  options = {
    layers: [
      tileLayer('https://maps.vnpost.vn/api/tm/{z}/{x}/{y}.png?apikey=e44a53dfa985cc29e58fef98b6ec12e333809d605238f045', { maxZoom: 15, attribution: '...' })
    ],
    zoom: 6,
    center: [17.438297, 106.274805]
  };

  Highcharts: typeof Highcharts = Highcharts;
  polarChartOptions: Highcharts.Options;
  itemHuongGio: any;
  currentUser: BasicUserInfo;

  constructor(
    private _tramDoService: TramDoService,
    private _globalService: GlobalService,
    private _tramDoGiaTriDoService: TramDoGiaTriDoService,
    private _authenticationService: AuthenticationService,
    private _router: Router,

  ) {
    this.currentUser = this._authenticationService.getCurrentUser();
  }

  private destroy$ = new Subject<void>();

  async ngOnInit() {
    await this.getData();
    this.getDataTramDo();
    interval(120000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getDataTramDo();
        console.log('Home interval running');
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  async getData() {
    await this._tramDoService.getsMyTramDo().then((res) => {
      if (res.success) {
        this.listTramDo = res.data;
        if (res.data.length > 0) {
          this.itemTramDo = res.data[0];
        }
      }
    });
  }

  getDataTramDo() {
    this.getDashboardData();
    this.renderMap();
  }

  myCustomOperator() {
    return pipe(
      startWith(""),
      switchMap(async () => this.getDataTramDo())
    );
  }

  getDashboardData() {
    this.chartDatas = [];
    this.dataSource = [];
    this.dataSource1 = [];
    this.chartDatas1 = [];
    this._tramDoGiaTriDoService.getForTvDashboard(this.itemTramDo.id).then(rs => {
      if (rs.success) {
        this.dataSource = rs.data.filter(x => x.codeDmYeuToDo != 'dd').slice(0, 2);
        this.dataSource.forEach(item => {
          this.chartDatas.push({
            labels: ['1:00', '7:00', '13:00', '19:00'],
            datasets: [
              {
                label: `Biểu đồ ${item.titleDmYeuToDo}`,
                data: item.listGiaTriDo.map(x => x.giaTri),
                backgroundColor: item.color,
              }
            ]
          });
        });

        rs.data.forEach(item => {
          if (this.dataSource.findIndex(x => x.id == item.id) < 0) {
            this.dataSource1.push(item);
            this.chartDatas1.push({
              labels: ['1:00', '7:00', '13:00', '19:00'],
              datasets: [
                {
                  label: `Biểu đồ ${item.titleDmYeuToDo}`,
                  data: item.listGiaTriDo.map(x => x.giaTri),
                  backgroundColor: item.color,
                }
              ]
            });
          }
        });

        var itemHuongGioTemp = rs.data.filter(x => x.codeDmYeuToDo == 'dd')[0];
        this.itemHuongGio = itemHuongGioTemp;
        var itemTocDoGio = rs.data.filter(x => x.codeDmYeuToDo == 'ff')[0];
        if (itemHuongGioTemp) {
          // Hướng gió và tỷ lệ gió

          let polarValue = itemHuongGioTemp.giaTri;
          let tocDoGio = itemTocDoGio.giaTri;
          let dataPolar = [];

          let colorStr = 'rgb(44, 175, 254)';
          if (tocDoGio >= 0.5 && tocDoGio < 2) {
            colorStr = 'rgb(84, 79, 197)'
          }
          else if (tocDoGio >= 2 && tocDoGio < 4) {
            colorStr = 'rgb(0, 226, 114)'
          }
          else if (tocDoGio >= 4 && tocDoGio < 6) {
            colorStr = 'rgb(254, 106, 53)'
          }
          else if (tocDoGio >= 6 && tocDoGio < 8) {
            colorStr = 'rgb(107, 138, 188)'
          }
          else if (tocDoGio >= 8 && tocDoGio < 10) {
            colorStr = 'rgb(213, 104, 251)'
          }
          else if (tocDoGio >= 10) {
            colorStr = 'rgb(46, 224, 202)'
          }

          if (polarValue < 12) {
            dataPolar = [tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (12 <= polarValue && polarValue < 34) {
            dataPolar = [0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (34 <= polarValue && polarValue < 57) {
            dataPolar = [0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (57 <= polarValue && polarValue < 79) {
            dataPolar = [0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (79 <= polarValue && polarValue < 102) {
            dataPolar = [0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (102 <= polarValue && polarValue < 124) {
            dataPolar = [0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (124 <= polarValue && polarValue < 147) {
            dataPolar = [0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (147 <= polarValue && polarValue < 169) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (169 <= polarValue && polarValue < 192) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0, 0]
          }
          else if (192 <= polarValue && polarValue < 214) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0, 0]
          }
          else if (214 <= polarValue && polarValue < 237) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0, 0]
          }
          else if (237 <= polarValue && polarValue < 259) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0, 0]
          }
          else if (259 <= polarValue && polarValue < 282) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0, 0]
          }
          else if (282 <= polarValue && polarValue < 304) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0, 0]
          }
          else if (304 <= polarValue && polarValue < 327) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio, 0]
          }
          else if (327 <= polarValue && polarValue < 349) {
            dataPolar = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, tocDoGio]
          }
          else if (polarValue >= 349) {
            dataPolar = [tocDoGio, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }

          this.polarChartOptions = {
            chart: { polar: true, type: 'column', backgroundColor: 'rgb(24, 27, 31)', borderColor: 'rgb(24, 27, 31)' },
            title: { text: '' },
            subtitle: { text: null },
            pane: { size: '80%' },
            legend: { align: 'left', verticalAlign: 'top', y: 50, layout: 'vertical', enabled: false },
            xAxis: {
              tickmarkPlacement: 'on'
              , categories: ["B", "BĐB", "ĐB", "ĐĐB", "Đ", "ĐĐN", "ĐN", "NĐN", "N", "NTN", "TN", "TTN", "T", "TTB", "TB", "BTB"],
              // lineColor: 'rgb(204, 204, 220)',
              labels: {
                style: {
                  color: 'rgb(204, 204, 220)',
                }
              },
              gridLineColor: 'rgb(96, 96, 96)',
            },
            yAxis: {
              min: 0,
              endOnTick: false,
              showLastLabel: false,
              title: { text: '' },
              lineColor: 'rgb(24, 27, 31)',
              gridLineColor: 'rgb(24, 27, 31)',
              // labels: {
              //   formatter: function () {
              //     return polarValue + ' độ';
              //   }
              // },
              reversedStacks: false,
              color: 'rgb(24, 27, 31)',
            },
            tooltip: { valueSuffix: ' m/s' },
            plotOptions: {
              series: {
                stacking: 'normal',
                shadow: false,
                pointPlacement: 'off'
              }
            },
            series: [
              {
                type: 'column',
                name: '',
                data: dataPolar,
                // pointPlacement: 'between'
              }
            ],
            colors: [
              colorStr
            ]
          }
        }

      }
    })
  }

  onChangeTramDo() {
    // console.log(this.itemTramDo);
    this.getDashboardData();
    this.renderMap();
  }

  getTenHuongGio(value: number) {

  }

  loadMap = () => {
    this.mapElement.nativeElement.innerHTML = "";
    const map = new window['google'].maps.Map(this.mapElement.nativeElement, {
      center: { lat: Number(this.itemTramDo.gpsLat), lng: Number(this.itemTramDo.gpsLong) },
      zoom: 6,
      mapId: 'demo-map'
    });

    if (this.itemTramDo.gpsLat !== null && this.itemTramDo.gpsLong !== undefined) {
      var trangThaiHoatDong = this.itemTramDo.trangThaiHoatDong != 1 ? this.itemTramDo.trangThaiHoatDong : this.itemTramDo.trangThaiHoatDongData;
      const marker = new window['google'].maps.Marker({
        position: { lat: parseFloat(this.itemTramDo.gpsLat), lng: parseFloat(this.itemTramDo.gpsLong) },
        map: map,
        title: this.itemTramDo.title,
        icon: `/assets/images/kttv/mapicon${trangThaiHoatDong}.png`,
      });

      // console.log(marker);

    }
  }

  async renderMap() {
    window['initMap'] = () => {
      this.loadMap();
    }
    if (!window.document.getElementById('google-map-script')) {
      var s = window.document.createElement("script");
      s.id = "google-map-script";
      s.type = "text/javascript";
      s.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyC89aP5P3qvEbBSOHtTISq0RZKdZDpjIhA&signed_in=true&callback=initMap&libraries=marker";

      window.document.body.appendChild(s);
    } else {
      this.loadMap();
    }
  }

  getTextHuongGio(giaTri) {
    if (giaTri < 12) {
      return "hướng bắc";
    }
    else if (12 <= giaTri && giaTri < 34) {
      return "hướng bắc đông bắc";
    }
    else if (34 <= giaTri && giaTri < 57) {
      return "hướng đông bắc";
    }
    else if (57 <= giaTri && giaTri < 79) {
      return "hướng đông đông bắc";
    }
    else if (79 <= giaTri && giaTri < 102) {
      return "hướng đông";
    }
    else if (102 <= giaTri && giaTri < 124) {
      return "hướng đông đông nam";
    }
    else if (124 <= giaTri && giaTri < 147) {
      return "hướng đông nam";
    }
    else if (147 <= giaTri && giaTri < 169) {
      return "hướng nam đông nam";
    }
    else if (169 <= giaTri && giaTri < 192) {
      return "hướng nam";
    }
    else if (192 <= giaTri && giaTri < 214) {
      return "hướng nam tây nam";
    }
    else if (214 <= giaTri && giaTri < 237) {
      return "hướng tây nam";
    }
    else if (237 <= giaTri && giaTri < 259) {
      return "hướng tây tây nam";
    }
    else if (259 <= giaTri && giaTri < 282) {
      return "hướng tây";
    }
    else if (282 <= giaTri && giaTri < 304) {
      return "hướng tây tây bắc";
    }
    else if (304 <= giaTri && giaTri < 327) {
      return "hướng tây bắc";
    }
    else if (327 <= giaTri && giaTri < 349) {
      return "hướng bắc tây bắc";
    }
    else if (giaTri >= 349) {
      return "hướng bắc";
    }
  }

  getTrangThaiHoatDong(trangThaiHoatDong: number, trangThaiHoatDongData: number) {
    switch (trangThaiHoatDong) {
      case 1:
        switch (trangThaiHoatDongData) {
          case 2:
            return 'Đang đo';
          case 3:
            return 'Hiệu chuẩn';
          case 4:
            return 'Kiểm tra';
          default:
            return '';
        }
      case 2:
        return 'Đang đo';
      case 3:
        return 'Hiệu chuẩn';
      case 4:
        return 'Kiểm tra';
      default:
        return '';
    }
  }

  getTrangThaiHoatDongStyle(trangThaiHoatDong: number, trangThaiHoatDongData: number) {
    switch (trangThaiHoatDong) {
      case 1:
        switch (trangThaiHoatDongData) {
          case 2:
            return 'text-success';
          case 3:
            return 'text-warning';
          case 4:
            return 'Kiểm tra';
          default:
            return 'Hiệu chuẩn';
        }
      case 2:
        return 'text-success';
      case 3:
        return 'text-warning';
      case 4:
        return 'Kiểm tra';
      default:
        return 'Hiệu chuẩn';
    }
  }

  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }
  logOut() {
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/authentication/signin']);
  }

}
